import { Stack, Typography } from "@mui/material"
import BookRoundedIcon from "@mui/icons-material/BookRounded"
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded"
import { useLocation } from "react-router-dom"

import LocalLibraryRoundedIcon from "@mui/icons-material/LocalLibraryRounded"
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded"
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded"
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded"

const pages = {
  classes: {
    name: "Classes",
    Icon: <LocalLibraryRoundedIcon color="primary" fontSize="large" />,
  },
  academic: {
    name: "Academic",
    Icon: <BookRoundedIcon color="primary" fontSize="large" />,
  },

  accounting: {
    name: "Accounting",
    Icon: <AccountBalanceRoundedIcon color="primary" fontSize="large" />,
  },

  admin: {
    name: "Admin",
    Icon: <AdminPanelSettingsRoundedIcon color="primary" fontSize="large" />,
  },

  assets: {
    name: "Assets",
    Icon: <WarehouseRoundedIcon color="primary" fontSize="large" />,
  },

  profile: {
    name: "Profile",
    Icon: <AccountCircleRoundedIcon color="primary" fontSize="large" />,
  },
}

const TabLogo = () => {
  const location = useLocation()
  const currentPage = location.pathname.split("/").filter((x) => x)[0]
  const { name, Icon } = pages[currentPage]
  return (
    <Stack
      direction="row"
      alignItems={"center"}
      gap={1}
      sx={{
        mr: 4,
        display: {
          xs: "none",
          sm: "flex",
        },
      }}
    >
      {Icon}
      <Typography fontWeight={700} variant="h6">
        {name}
      </Typography>
    </Stack>
  )
}

export default TabLogo
